if (typeof Shopify === 'undefined' || !Shopify.designMode) {
  (function () {
    var redirects = {
      '/products/neckslevel-glide': 'https://neckslevel.com/products/glide',
      '/products/pro-clinic-bundle': 'https://neckslevel.com/products/pro-clinic-bundle-1',
      '/products/neckslevel-glide-pro': 'https://neckslevel.com/products/glidepro'
    };

    var currentPath = window.location.pathname;
    if (redirects[currentPath]) {
      window.location.href = redirects[currentPath];
    }
  })();
}

const popupCheck = setInterval(function () {
  const $popup = jQuery('[data-testid="POPUP"]');
  const $shopNowButton = $popup.find('button[type="button"]');
  const $emailField = $popup.find('[type="email"]');

  if ($shopNowButton.html() === "SHOP NOW" && $emailField.length === 0) {
    // Set the cookie to indicate subscription
    document.cookie = "email_subscribed=true; path=/; max-age=" + 60 * 60 * 24 * 30; // 30 days
    if (window.location.pathname.includes('/product') && !window.location.href.includes('/discount/')) {
      const currentPath = window.location.pathname + window.location.search + window.location.hash;
      const newUrl = '/discount/STRENGTH%2520UPGRADE?redirect=' + encodeURIComponent(currentPath);
      window.location.href = newUrl;
    }


    // Append discount to all <a> links
    jQuery('a').each(function () {
      const $link = jQuery(this);
      const href = $link.attr('href');

      if (href && href.startsWith('/') && !href.includes('discount=')) {
        $link.attr('href', '/discount/STRENGTH%2520UPGRADE?redirect=' + encodeURIComponent(href));
      } else if (href && href.startsWith('https://neckslevel.com') && !href.includes('discount=')) {
        const parts = href.split('?');
        const path = parts[0].replace('https://neckslevel.com', '');
        const query = parts[1] ? '?' + parts[1] : '';
        $link.attr('href', 'https://neckslevel.com/discount/STRENGTH%2520UPGRADE?redirect=' + encodeURIComponent(path + query));
      }
    });

     

    // Stop checking
    clearInterval(popupCheck);
  }
}, 1000);



function checkEmailSubscribedCookie() {
  const isSubscribed = document.cookie
    .split('; ')
    .some(cookie => cookie.startsWith('email_subscribed='));

  if (isSubscribed) {
    var ur = window.location.href;
if(ur.includes('/glide')){
      function hasStrengthDiscountCookie() {
      return document.cookie
        .split('; ')
        .some(cookie => cookie === 'discount_code=STRENGTH+UPGRADE');
    }

    // Usage
    if (!hasStrengthDiscountCookie() && isSubscribed) {
     const currentPath = window.location.pathname + window.location.search + window.location.hash;
      const newUrl = '/discount/STRENGTH%2520UPGRADE?redirect=' + encodeURIComponent(currentPath);
    window.location.href = newUrl;
      // You can run your logic here
    }
    jQuery('.strength-upgrade-wrapper').addClass('is-free');
  }
    
  
  }
}

// Call the function when the DOM is ready
jQuery(document).ready(function () {
  checkEmailSubscribedCookie();
  $('.box-2 .product-form__submit.button.button--primary').eq(1).html($('.box-2 .product-form__submit.button.button--primary').eq(0).html())
});


